/**
 * Created by Simon on 15/12/2016.
 */
/*
import Stream from '../../stream/index';





function parseDocument( string, offset=0){
    return document().parse(Stream.ofString(string), offset)
}


export default {
  //  document,

    // TODO: not exact, because we always need a stream here
    parse(stream){
        return parseDocument(stream,0);
    }
}*/
